import * as Tooltip from '@radix-ui/react-tooltip';
import { forwardRef, memo, type ReactNode } from 'react';
import { classNames } from '~/utils/classNames';

export { Arrow, Portal, Provider, Root, Trigger } from '@radix-ui/react-tooltip';

type TooltipContentProps = {
  children: ReactNode;
  truncate?: boolean;
  hideArrow?: boolean;
  maxWidth?: string | number;
} & Pick<
  Tooltip.TooltipContentProps,
  'side' | 'align' | 'sideOffset' | 'alignOffset' | 'avoidCollisions' | 'collisionPadding'
>;

const TooltipContent = memo(
  forwardRef<HTMLDivElement, TooltipContentProps>(({ maxWidth, hideArrow, truncate, children, ...props }, ref) => {
    return (
      <Tooltip.Content
        ref={ref}
        className={classNames(
          'z-max text-xs bg-gray-950 text-white border border-bolt-elements-borderColor rounded-lg px-2 py-1.5 ',
          {
            truncate: truncate === true || truncate === undefined,
          },
        )}
        style={{
          ...(maxWidth === undefined
            ? undefined
            : { maxWidth: typeof maxWidth === 'string' ? maxWidth : `${maxWidth}px` }),
        }}
        {...props}
      >
        {!hideArrow && <Tooltip.Arrow className="dark:fill-bolt-elements-borderColor" />}
        {children}
      </Tooltip.Content>
    );
  }),
);

export { TooltipContent as Content };
